<div class="file-send-modal-overlay" *ngIf="visible" (click)="closeModal()">
  <div class="file-send-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <button class="close-btn" (click)="closeModal()">
        <i class="pi pi-times"></i>
      </button>
      <h3>{{ 'Send Photo' | translate }}</h3>
      <button class="options-btn">
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </div>

    <!-- File Preview Section -->
    <div class="file-preview-section">
      <div class="file-preview-container" *ngFor="let fileItem of filesWithCaptions; let i = index">

        <!-- Image Preview -->
        <div class="file-preview" *ngIf="isImage(fileItem.file)">
          <img [src]="getFilePreview(fileItem.file)" [alt]="fileItem.file.name" />
          <button class="remove-file-btn" (click)="removeFile(i)" *ngIf="filesWithCaptions.length > 1">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Non-Image File Preview -->
        <div class="file-document-preview" *ngIf="!isImage(fileItem.file)">
          <div class="file-icon-container">
            <i class="pi" [ngClass]="getFileIcon(fileItem.file)"></i>
          </div>
          <div class="file-info">
            <div class="file-name">{{ fileItem.file.name }}</div>
            <div class="file-size">{{ getFileSize(fileItem.file.size) }}</div>
          </div>
          <button class="remove-file-btn" (click)="removeFile(i)" *ngIf="filesWithCaptions.length > 1">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Caption Input for each file -->
        <div class="caption-section" *ngIf="filesWithCaptions.length > 1">
          <input
            type="text"
            class="caption-input"
            [placeholder]="'Add a caption...' | translate"
            [(ngModel)]="fileItem.caption">
        </div>
      </div>
    </div>

    <!-- Message Input Section -->
    <div class="message-section">
      <div class="message-input-container">
        <input
          type="text"
          class="message-input"
          [placeholder]="filesWithCaptions.length === 1 ? ('Add a caption...' | translate) : ('Message...' | translate)"
          [(ngModel)]="message">

        <button class="send-btn" (click)="sendFiles()" [disabled]="filesWithCaptions.length === 0">
          <span>{{ 'SEND' | translate }}</span>
          <i class="pi pi-send"></i>
        </button>
      </div>
    </div>
  </div>
</div>
